import data from './jobsData.json';

export const categories = data.categories.map(cat => ({
  ...cat,
  count: data.jobs.filter(j => j.categories.includes(cat.id)).length,
}));

export const qualifications = data.qualifications.map(q => ({
  ...q,
  count: data.jobs.filter(j => j.categories.includes(q.id)).length,
}));

export const getAllJobs = () => data.jobs;

export const getJobsByCategory = (catId) =>
  data.jobs.filter(j => j.categories.includes(catId));

export const getJobById = (jobId) =>
  data.jobs.find(j => j.id === jobId) || null;

export const getCategoryById = (id) =>
  [...data.categories, ...data.qualifications].find(c => c.id === id);
